var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { width: "100%", height: "100%" } },
    _vm._l(_vm.lines, function(line) {
      return _c("NodeLink", {
        key: line.id,
        attrs: { line: line },
        on: {
          editNodeLinks: function($event) {
            return _vm.editNode($event, line)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }